module.exports = __webpack_public_path__ + "static/media/21b Sprawl.4df2abb9.jpg";